import serviceUserRequest from '@ertelecom/ui-react/components/requests/serviceUserRequest';

export enum ESendByCallPetitions {
    ProblemNew = 'problem_new',
    RequestNew = 'request_new',
}

export interface ISendByCallParams {
    fio?: string,
    phone: string,
    petition: ESendByCallPetitions
}

type TData = {
    status: number,
    message: string,
}
export interface ISendByCallResult {
    status: number,
    message?: string,
    data?: TData
}

/**
 * GET-запрос обратного звонка /user/by-call
 * @param {string} cityDomain поддомен хоста b2c
 * @param {{phone:string,petition:string,fio:string}} params
 * @return {object} { status: 1, message: "Заявка успешно создана." }
 */
export const sendByCall = async(cityDomain: string, params: ISendByCallParams): Promise<ISendByCallResult> => {
    try {
        const resp = await serviceUserRequest(cityDomain).get('/user/by-call', { params });

        return resp.data;

    } catch (err) {
        return {
            status: 0,
            message: err?.response?.data?.message,
            data: err?.response?.data,
        };
    }
};
